// frontend/src/components/layout/MobileBottomNav.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaShoppingCart, FaWarehouse, FaUser } from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';

function MobileBottomNav() {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  // Determine active path for highlighting
  const isActive = (path) => location.pathname === path;

  // Garage Link Logic: If logged in -> My Garage. If not -> Intro Page.
  const garageLink = isAuthenticated ? '/account?tab=garage' : '/garage-benefits';
  
  // Account Link Logic: If logged in -> Account. If not -> Login.
  const accountLink = isAuthenticated ? '/account' : '/login';

  const navItems = [
    { label: 'Home', icon: FaHome, path: '/' },
    { label: 'Shop', icon: FaShoppingCart, path: '/parts' },
    { label: 'Garage', icon: FaWarehouse, path: garageLink },
    { label: 'Account', icon: FaUser, path: accountLink },
  ];

  return (
    <div className="md:hidden fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 shadow-[0_-2px_10px_rgba(0,0,0,0.05)] z-40 h-16 flex items-center justify-around px-2">
      {navItems.map((item) => {
        const active = isActive(item.path) || (item.label === 'Garage' && location.search.includes('garage'));
        
        return (
          <Link
            key={item.label}
            to={item.path}
            className={`flex flex-col items-center justify-center w-full h-full space-y-1 ${
              active ? 'text-primary' : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            <item.icon size={20} className={active ? 'animate-bounce' : ''} />
            <span className="text-[10px] font-medium">{item.label}</span>
          </Link>
        );
      })}
    </div>
  );
}

export default MobileBottomNav;